import React from 'react';
import Button from 'seedly-component-library/button-new';
import { Gift } from 'react-feather';
import { openLoginModal } from 'dispatcher/modalDispatcher';
import { useDispatch } from 'react-redux';
import mixpanel, { trackedEvents } from 'utils/mixpanel';
import useIsMobile from 'utils/hooks/useIsMobile';

const NonSignedInUserDashboard = () => {
  const isMobile = useIsMobile();
  const dispatch = useDispatch();

  return (
    <div className="flex flex-col  w-full">
      <div className="flex gap-3 flex-col lg:flex-row justify-between w-full lg:items-center">
        <div className="flex gap-3 items-center">
          <Gift size={isMobile ? 42 : 24} color="white" />
          <p className="text-white">
            Sign up for a free account to start earning rewards on Seedly!
          </p>
        </div>
        <Button
          onClick={() => {
            dispatch(openLoginModal());
            mixpanel.track(trackedEvents.RewardsCollection, {
              param: 'sign_up_rewards',
            });
          }}
          variant="primaryWhite"
          isBlock={isMobile}
        >
          Join Seedly
        </Button>
      </div>
    </div>
  );
};

export default NonSignedInUserDashboard;
